<div class="container">
  <!-- Current Plan Section -->
  <section class="billing-section">
    <div class="d-flex align-items-center justify-content-between">
      <h2 class="section-title">Current Plan</h2>
      <button class="btn btn-primary d-flex align-items-center gap-2">
        <span>Upgrade Plan</span>
        <i class="bi bi-arrow-up-circle"></i>
      </button>
    </div>
    <hr />
    
    <div class="row g-4">
      <div class="col-md-8">
        <div class="plan-card p-4 rounded-4 shadow-sm bg-white">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <div>
              <h3 class="plan-name mb-1">Professional Plan</h3>
              <p class="text-muted mb-0">Perfect for growing teams</p>
            </div>
            <div class="text-end">
              <div class="plan-price">$49<span class="text-muted">/month</span></div>
              <div class="text-success fw-500">Active</div>
            </div>
          </div>
          
          <div class="row g-3">
            <div class="col-sm-6">
              <div class="feature-item">
                <i class="bi bi-check-circle-fill text-success me-2"></i>
                <span>Up to 25 team members</span>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="feature-item">
                <i class="bi bi-check-circle-fill text-success me-2"></i>
                <span>Unlimited projects</span>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="feature-item">
                <i class="bi bi-check-circle-fill text-success me-2"></i>
                <span>Advanced analytics</span>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="feature-item">
                <i class="bi bi-check-circle-fill text-success me-2"></i>
                <span>Priority support</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-md-4">
        <div class="usage-card p-4 rounded-4 shadow-sm bg-white">
          <h4 class="mb-3">Usage This Month</h4>
          
          <div class="usage-item mb-3">
            <div class="d-flex justify-content-between mb-1">
              <span class="text-muted">Team Members</span>
              <span class="fw-500">12 / 25</span>
            </div>
            <div class="progress" style="height: 6px;">
              <div class="progress-bar" role="progressbar" style="width: 48%"></div>
            </div>
          </div>
          
          <div class="usage-item mb-3">
            <div class="d-flex justify-content-between mb-1">
              <span class="text-muted">Projects</span>
              <span class="fw-500">8 / ∞</span>
            </div>
            <div class="progress" style="height: 6px;">
              <div class="progress-bar" role="progressbar" style="width: 25%"></div>
            </div>
          </div>
          
          <div class="usage-item">
            <div class="d-flex justify-content-between mb-1">
              <span class="text-muted">Storage</span>
              <span class="fw-500">2.4 GB / 100 GB</span>
            </div>
            <div class="progress" style="height: 6px;">
              <div class="progress-bar" role="progressbar" style="width: 2.4%"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Payment Methods Section -->
  <section class="billing-section">
    <div class="d-flex align-items-center justify-content-between">
      <h2 class="section-title">Payment Methods</h2>
      <button class="btn btn-primary d-flex align-items-center gap-2">
        <span>Add Payment Method</span>
        <i class="bi bi-plus-circle"></i>
      </button>
    </div>
    <hr />
    
    <div class="row g-3">
      <div class="col-md-6">
        <div class="payment-card p-3 rounded-4 shadow-sm bg-white">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center gap-3">
              <div class="payment-icon">
                <i class="bi bi-credit-card-fill text-primary"></i>
              </div>
              <div>
                <div class="fw-500">•••• •••• •••• 4242</div>
                <div class="text-muted">Expires 12/25</div>
              </div>
            </div>
            <div class="d-flex align-items-center gap-2">
              <span class="badge bg-success">Primary</span>
              <div class="dropdown">
                <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                  <i class="bi bi-three-dots"></i>
                </button>
                <ul class="dropdown-menu">
                  <li><a class="dropdown-item" href="#">Edit</a></li>
                  <li><a class="dropdown-item text-danger" href="#">Remove</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-md-6">
        <div class="payment-card p-3 rounded-4 shadow-sm bg-white">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center gap-3">
              <div class="payment-icon">
                <i class="bi bi-paypal text-primary"></i>
              </div>
              <div>
                <div class="fw-500">PayPal Account</div>
                <div class="text-muted">john&#64;example.com</div>
              </div>
            </div>
            <div class="dropdown">
              <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                <i class="bi bi-three-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li><a class="dropdown-item" href="#">Set as Primary</a></li>
                <li><a class="dropdown-item text-danger" href="#">Remove</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Billing History Section -->
  <section class="billing-section">
    <div class="d-flex align-items-center justify-content-between">
      <h2 class="section-title">Billing History</h2>
      <button class="btn btn-outline-secondary d-flex align-items-center gap-2">
        <span>Download All</span>
        <i class="bi bi-download"></i>
      </button>
    </div>
    <hr />
    
    <div class="table-card p-3 rounded-4 shadow-sm bg-white">
      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead>
            <tr>
              <th scope="col">Date</th>
              <th scope="col">Description</th>
              <th scope="col">Amount</th>
              <th scope="col">Status</th>
              <th scope="col" class="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Oct 1, 2024</td>
              <td>Professional Plan - Monthly</td>
              <td>$49.00</td>
              <td><span class="badge bg-success">Paid</span></td>
              <td class="text-end">
                <button class="btn btn-sm btn-outline-secondary">
                  <i class="bi bi-download"></i>
                </button>
              </td>
            </tr>
            <tr>
              <td>Sep 1, 2024</td>
              <td>Professional Plan - Monthly</td>
              <td>$49.00</td>
              <td><span class="badge bg-success">Paid</span></td>
              <td class="text-end">
                <button class="btn btn-sm btn-outline-secondary">
                  <i class="bi bi-download"></i>
                </button>
              </td>
            </tr>
            <tr>
              <td>Aug 1, 2024</td>
              <td>Professional Plan - Monthly</td>
              <td>$49.00</td>
              <td><span class="badge bg-success">Paid</span></td>
              <td class="text-end">
                <button class="btn btn-sm btn-outline-secondary">
                  <i class="bi bi-download"></i>
                </button>
              </td>
            </tr>
            <tr>
              <td>Jul 1, 2024</td>
              <td>Professional Plan - Monthly</td>
              <td>$49.00</td>
              <td><span class="badge bg-success">Paid</span></td>
              <td class="text-end">
                <button class="btn btn-sm btn-outline-secondary">
                  <i class="bi bi-download"></i>
                </button>
              </td>
            </tr>
            <tr>
              <td>Jun 1, 2024</td>
              <td>Starter Plan - Monthly</td>
              <td>$19.00</td>
              <td><span class="badge bg-success">Paid</span></td>
              <td class="text-end">
                <button class="btn btn-sm btn-outline-secondary">
                  <i class="bi bi-download"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

  <!-- Billing Settings Section -->
  <section class="billing-section">
    <div class="d-flex align-items-center justify-content-between">
      <h2 class="section-title">Billing Settings</h2>
    </div>
    <hr />
    
    <div class="row g-4">
      <div class="col-md-6">
        <div class="settings-card p-4 rounded-4 shadow-sm bg-white">
          <h4 class="mb-3">Billing Information</h4>
          
          <div class="mb-3">
            <label class="form-label">Company Name</label>
            <input type="text" class="form-control" value="Acme Corporation" readonly />
          </div>
          
          <div class="mb-3">
            <label class="form-label">Billing Email</label>
            <input type="email" class="form-control" value="billing&#64;acme.com" readonly />
          </div>
          
          <div class="mb-3">
            <label class="form-label">Tax ID</label>
            <input type="text" class="form-control" value="123-456-789" readonly />
          </div>
          
          <button class="btn btn-outline-primary">Edit Information</button>
        </div>
      </div>
      
      <div class="col-md-6">
        <div class="settings-card p-4 rounded-4 shadow-sm bg-white">
          <h4 class="mb-3">Billing Address</h4>
          
          <div class="mb-3">
            <label class="form-label">Street Address</label>
            <input type="text" class="form-control" value="123 Business St" readonly />
          </div>
          
          <div class="row g-2 mb-3">
            <div class="col-8">
              <label class="form-label">City</label>
              <input type="text" class="form-control" value="San Francisco" readonly />
            </div>
            <div class="col-4">
              <label class="form-label">State</label>
              <input type="text" class="form-control" value="CA" readonly />
            </div>
          </div>
          
          <div class="row g-2 mb-3">
            <div class="col-6">
              <label class="form-label">ZIP Code</label>
              <input type="text" class="form-control" value="94105" readonly />
            </div>
            <div class="col-6">
              <label class="form-label">Country</label>
              <input type="text" class="form-control" value="United States" readonly />
            </div>
          </div>
          
          <button class="btn btn-outline-primary">Edit Address</button>
        </div>
      </div>
    </div>
  </section>
</div>
